<template>
    <section class="font-poppins">
        <div class="flex justify-between mb-20">
            <div class="w-2/3 md:w-full md:p-2">
                <div class="flex justify-between mt-8">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">4/4</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 md:text-lg">
                            <h2 class="text-blue-600 font-semibold " style="color:rgb(18,84,179)">Sign Up as a DSP Carrier</h2>
                        </div>
                        <div class="w-4/5 md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Upload Document</p>
                                <p class="mt-1 font-medium">upload only pdf, jpg, jpeg or png</p>
                            </div>
                            <div class="mt-5">
                                <form @submit.prevent="submitDetails" enctype="multipart/form-data">
                                    <div>
                                        <div>
                                            <label for="selectedIdCard" class=" font-bold"> ID Card Type</label><br>
                                            <select class="bg-gray-100 border w-full p-1 rounded-lg" name="selectedIdCard" id="selectedIdCard" v-model="selectedIdCard">
                                                <option value="" disabled>Select ID Card Type</option>
                                                <option value="Voters Card">Voters card</option>
                                                <option value="ID Card">National ID Card</option>
                                                <option value="Reg. Company Card">Reg. Company Card</option>
                                            </select>
                                            <p v-if="selectedIdCardValidity === 'invalid'" class=" text-xs text-red-500">this field must not be empty</p>

                                            <div>
                                                <input style="display:none" type="file" name="idCard" id="idCard" @change="onIdCard" ref="idCardUpload">
                                                <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.idCardUpload.click()">--upload file-- {{this.idCardName}} </p>
                                                <p v-if="idCardValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                                <p v-if="idFileError" class=" text-xs text-red-500">{{idFileError}}</p>
                                            </div>
                                            
                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="passort">Passport</label>
                                                <input style="display:none" type="file" name="passport" id="passport" @change="onPassport" ref="passportUpload">
                                                <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.passportUpload.click()">--upload file-- {{this.passportName}} </p>

                                                <p v-if="passportValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                                <p v-if="passportFileError" class=" text-xs text-red-500">{{passportFileError}}</p>
                                            </div>

                                        </div>

                                         <div class="mt-4">
                                            <label class="font-bold" for="roadWorthiness">Road Worthiness</label>
                                            <input style="display:none" type="file" name="roadWorthiness" id="roadWorthiness" @change="onRoadWorthiness" ref="roadWorthinessUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.roadWorthinessUpload.click()">--upload file-- {{this.roadWorthinessName}} </p>
                                            <p v-if="roadWorthinessValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="roadFileError" class=" text-xs text-red-500">{{roadFileError}}</p>
                                        </div>
                                        
                                         <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="passort">Hackney Permit</label>
                                                <input style="display:none; " type="file" name="hackneyPermit" id="hackneyPermit" @change="onHackney" ref="hackneyPermitUpload">
                                                <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" style=" border:1px solid rgb(18,84,179) " @click="$refs.hackneyPermitUpload.click()">--upload file-- {{this.hackneyName}} </p>
                                                <p v-if="hackneyValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                                <p v-if="hackneyFileError" class=" text-xs text-red-500">{{hackneyFileError}}</p>
                                            </div>
                                         </div>  
                                         
                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="model">Vehicle Model</label><br>
                                                <input class="border w-full text-sm rounded-lg bg-gray-100 p-2" type="text" name="passport" id="passport" placeholder="Enter Vehicle Model" v-model="vehicleModel">
                                                <p v-if="vehicleModelValidity === 'invalid'" class=" text-xs text-red-500">this field cannot be empty</p>
                                            </div>

                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="license">License Plate No.</label><br>
                                                <input class="border w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="licenseNo" id="licenseNo" placeholder="Enter Your Plate No." v-model="license">
                                                <p v-if="licenseValidity === 'invalid'" class=" text-xs text-red-500">this field cannot be empty</p>
                                          </div>
                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="engineNumber">Engine Number</label><br>
                                                <input class="border  w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="egineNumber" id="engineNumber" placeholder="Enter Your Engine Here." v-model="engine">
                                                <p v-if="engineValidity === 'invalid'" class=" text-xs text-red-500">this field cannot be empty</p>
                                          </div>
                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="chassisNumber">Chassis Number</label><br>
                                                <input class="border w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="chassisNumber" id="chassisNumber" placeholder="Type here" v-model="chasis">
                                                <p v-if="chasisValidity === 'invalid'" class=" text-xs text-red-500">this field cannot be empty</p>
                                          </div>
                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="autovin">Autovin</label><br>
                                                <input class="border  w-full rounded-lg bg-gray-100 p-2 text-sm" type="text" name="autovin" id="autovin" placeholder="Type here" v-model="autovin">
                                                <p v-if="autovinValidity === 'invalid'" class=" text-xs text-red-500">this field cannot be empty</p>
                                          </div>
                                        </div>

                                        <div class="mt-4">
                                            <label for="vehicleReceipt" class=" font-bold">Vehicle Receipt</label><br>
                                            <input style="display:none" type="file" name="vehicleReceipt" id="vehicleReceipt" @change="onVehicleReceipt" ref="vehicleReceiptUpload">
                                            <p class="w-full text-sm p-2 bg-gray-100 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.vehicleReceiptUpload.click()">--upload file--{{this.vehicleReceiptName}}</p>
                                            <p v-if="vehicleReceiptValidity === 'invalid'" class=" text-xs text-red-500">please upload file</p>
                                            <p v-if="receiptFileError" class=" text-xs text-red-500">{{receiptFileError}}</p>
                                        </div>
                                       
                                        <div class="mt-4">
                                            <label for="OriginCertificate" class=" font-bold">Certificate of Origin</label><br>
                                            <input style="display:none" type="file" name="originCertificate" id="state-certificate" @change="onOriginCertificate" ref="originUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.originUpload.click()">--upload file-- {{this.originCertificateName}} </p>
                                            <p v-if="originCertificateValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="certFileError" class=" text-xs text-red-500">{{certFileError}}</p>
                                        </div>

                                    </div>

                                    <div>
                                        <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a @click="showPolicy" class="text-blue-500 cursor-pointer" >Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer" >Privacy policy</a>
                                            </p>
                                        </div>
                                        <p v-if="checkValidity === 'invalid'" class=" text-xs text-red-500">Accept T&C to proceed</p>
                                    </div>
                                     <p class="text-red-500 text-sm">{{error}}</p>

                                    <div class="mt-10 flex">
                                        <button type="submit" class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>

            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>

        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
import TermsPolicyModal from '../TermsPolicyModal.vue';
export default {
    components:{TermsPolicyModal},
    data() {
        return {
            emailInput: '',
            selectedIdCard: '',
            idCard: null,
            idCardName: null,
            passport: null,
            passportName: null,
            originCertificate: null,
            originCertificateName: null,
            roadWorthiness: null,
            roadWorthinessName: "",
            vehicleModel: "",
            license : "",
            engine :"",
            chasis: "",
            autovin:"",
            vehicleReceipt:null,
            vehicleReceiptName:"",
            hackney: null,
            hackneyName: null,

            checkbox: '',
            error: '',
            
            selectedIdCardValidity: '',
            roadWorthinessValidity:"",
            idCardValidity: '',
            passportValidity: '',
            licenseValidity:"",
            engineValidity:"",
            chasisValidity:"",
            hackneyValidity: '',
            originCertificateValidity: '',
            autovinValidity:"",
            vehicleReceiptValidity: "",
            vehicleModelValidity:"",
            checkValidity: '',
            termsPolicy:false,
            isLoading: false,
            idFileError: "",
            roadFileError: "",
            hackneyFileError: "",
            passportFileError: "",
            receiptFileError: "",
            certFileError:""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        showPolicy() {
            this.termsPolicy = true;
        },
         closeModal() {
            this.termsPolicy = false;
        },
        onIdCard(event) {
            this.idCard = event.target.files[0]
            this.idCardName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.idFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.idFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.idFileError = "";
                }, 1000);
            }
        },
        onPassport(event) {
            this.passport = event.target.files[0]
            this.passportName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.passportFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.passportFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.passportFileError = "";
                }, 1000);
            }
        },
        onOriginCertificate(event) {
            this.originCertificate = event.target.files[0]
            this.originCertificateName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.certFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.certFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.certFileError = "";
                }, 1000);
            }
        },

        onRoadWorthiness(event) {
            this.roadWorthiness = event.target.files[0]
            this.roadWorthinessName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.roadFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.roadFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.roadFileError = "";
                }, 1000);
            }
        },
        onHackney(event) {
            this.hackney = event.target.files[0]
            this.hackneyName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.hackneyFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.hackneyFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.hackneyFileError = "";
                }, 1000);
            }
        },
        onVehicleReceipt(event) {
            this.vehicleReceipt = event.target.files[0]
            this.vehicleReceiptName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.receiptFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.receiptFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.receiptFileError = "";
                }, 1000);
            }
        },
        
        submitDetails() {
            this.networkError();
            if (!this.selectedIdCard) {
                this.selectedIdCardValidity = 'invalid';
                setTimeout(() => {
                        this.selectedIdCardValidity = "";
                    }, 3000);
            } else if (!this.idCard && !this.idFileError) {
                this.idCardValidity = 'invalid';
                setTimeout(() => {
                        this.idCardValidity = "";
                    }, 3000);
            } else if (!this.passport && !this.passportFileError) {
                this.passportValidity = 'invalid';
                setTimeout(() => {
                        this.passportValidity = "";
                    }, 3000);
            } else if (!this.roadWorthiness && !this.roadFileError) {
                this.roadWorthinessValidity = 'invalid';
                setTimeout(() => {
                        this.roadWorthinessValidity = "";
                    }, 3000);
            } else if (!this.hackney && !this.hackneyFileError) {
                this.hackneyValidity = 'invalid';
                 setTimeout(() => {
                    this.hackneyValidity = "";
                }, 3000);
            } else if (!this.vehicleModel) {
                this.vehicleModelValidity = 'invalid';
                setTimeout(() => {
                        this.vehicleModelValidity = "";
                    }, 3000);
            } else if (!this.license) {
                this.licenseValidity = 'invalid';
                setTimeout(() => {
                        this.licenseValidity = "";
                    }, 3000);
            }else if (!this.engine) {
                this.engineValidity = 'invalid';
                setTimeout(() => {
                        this.engineValidity = "";
                    }, 3000);
            }else if (!this.chasis) {
                this.chasisValidity = 'invalid';
                setTimeout(() => {
                        this.chasisValidity = "";
                    }, 3000);
            }
            else if (!this.autovin) {
                this.autovinValidity = 'invalid';
                setTimeout(() => {
                        this.autovinValidity = "";
                    }, 3000);
            } else if (!this.vehicleReceipt && !this.receiptFileError) {
                this.vehicleReceiptValidity = 'invalid';
                setTimeout(() => {
                        this.vehicleReceiptValidity = "";
                    }, 3000);
            }
            else if (!this.originCertificate && !this.certFileError ) {
                this.originCertificateValidity = 'invalid';
                setTimeout(() => {
                        this.originCertificateValidity = "";
                    }, 3000);
            }else if(!this.checkbox) {
                this.checkValidity = 'invalid';
                setTimeout(() => {
                        this.checkValidity = "";
                    }, 3000);
            }
            else {
                this.isLoading = true;
                let data = new FormData()

                data.append('email', localStorage.getItem("riderEmail"));
                data.append('selectedIdCard', this.selectedIdCard); 
                data.append('idCard', this.idCard); 
                data.append('passport', this.passport); 
                data.append('originCertificate', this.originCertificate); 
                data.append('roadWorthiness', this.roadWorthiness); 
                data.append('hackneyPermit', this.hackney); 
                data.append('vehicleModel', this.vehicleModel); 
                data.append('licenseNumber', this.license); 
                data.append('engineNumber', this.engine); 
                data.append('chasisNumber', this.chasis); 
                data.append('autoVin', this.autovin); 
                data.append('vehicleReceipt', this.vehicleReceipt);
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/riders/update`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data:data
                })
                .then((response) => {
                    response.json
                    this.$store.commit("setAuthentication", true)  ;          
                    this.isLoading = false;
                    this.$router.push('/success');
                    localStorage.removeItem("riderEmail");
                    localStorage.removeItem("riderPhone");
                })

                .catch((error) => {
                    this.error = error.response.data.message;
                    setTimeout(() => {
                        this.error = "";
                    }, 3000);
                    this.isLoading = false;
                });
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
